import { useEffect } from "react";
import { useState } from "react";

import { Loading } from "../../common/components/Loading";
import { InfoPersonal } from "../components/NuevoAcolito/InfoPersonal";
import { ConocimientoPuestos } from "../components/NuevoAcolito/ConocimientoPuestos";
import { Disponibilidad } from "../components/NuevoAcolito/Disponibilidad";
import { Info, KeyboardReturn, Save } from "@mui/icons-material";
import { CustomModal } from "../../common/components/CustomModal";
import { Alert, Button, Snackbar } from "@mui/material";
import { addPuestos } from "../../helpers/puestos";
import { generarID } from "../../helpers/generarID";
import {
  addAcolito,
  updateDisponibilidadAcolito,
} from "../../helpers/acolitos";

export const NuevoAcolito = () => {
  //nombre de la pestaña
  document.title = "Nuevo acólito";

  const [acolito, setAcolito] = useState({
    id: 1,
    nombre_completo: "",
    nombre: "",
    nombre2: null,
    apellido_p: "",
    apellido_m: "",
    correo: "",
    celular: "",
    estatura: null,
    ID_equipo_actual: null,
    equipo_actual: null,
    estatus: 0,
    fecha_nacimiento: "",
    id_cargo: null,
    cargo: "",
    medalla: 0,
  });
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [puestosAcolito, setPuestosAcolito] = useState([]);
  const [horarios, setHorarios] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(
    "Error: faltan campos por llenar."
  );
  const [loadingText, setLoadingText] = useState("Obteniendo información");
  const [showCambiosGuardados, setShowCambiosGuardados] = useState(false);

  const getData = async () => {
    const id = await generarID();
    setAcolito({ ...acolito, id: id });
    setLoading(false);
  };
  const validarCampos = () => {
    if (
      acolito.nombre === "" ||
      acolito.nombre === undefined ||
      acolito.nombre.trim() === ""
    ) {
      setErrorAlert("Error: el nombre no puede estar vacío.");
      return false;
    }
    if (
      acolito.apellido_p === "" ||
      acolito.apellido_p === undefined ||
      acolito.apellido_p.trim() === ""
    ) {
      setErrorAlert("Error: el apellido paterno no puede estar vacío.");
      return false;
    }
    if (
      acolito.apellido_m === "" ||
      acolito.apellido_m === undefined ||
      acolito.apellido_m.trim() === ""
    ) {
      setErrorAlert("Error: el apellido materno no puede estar vacío.");
      return false;
    }
    if (acolito.fecha_nacimiento === "Invalid Date") {
      setErrorAlert("Error: fecha de nacimiento inválida.");
      return false;
    }
    if (
      acolito.celular === "" ||
      acolito.celular === undefined ||
      acolito.celular.trim() === ""
    ) {
      setErrorAlert("Error: el celular no puede estar vacío.");
      return false;
    }
    if (
      acolito.correo === "" ||
      acolito.correo === undefined ||
      acolito.correo.trim() === ""
    ) {
      setErrorAlert("Error: el correo no puede estar vacío.");
      return false;
    }
    if (
      acolito.id_cargo === "" ||
      acolito.id_cargo === undefined ||
      acolito.id_cargo === null
    ) {
      setErrorAlert("Error: el rango no puede estar vacío.");
      return false;
    }
    if (horarios.length !== 0) {
      //Checar que todos los horarios tengan un día de la semana y una hora
      for (let i = 0; i < horarios.length; i++) {
        if (horarios[i].dia_semana === null) {
          setErrorAlert("Error: falta seleccionar un día de la semana.");
          return false;
        }
        if (horarios[i].hora === "" || horarios[i].hora.trim() === "") {
          setErrorAlert("Error: falta seleccionar una hora.");
          return false;
        }
      }
    }

    return true;
  };

  const guardarCambios = async () => {
    setShowModal(false);
    let error = true;
    if (validarCampos()) {
      error = false;
      //Guardar cambios
      setGuardando(true);
      setLoading(true);
      setLoadingText("Guardando información del acólito");
      const responseAC = await addAcolito(acolito);
      if (responseAC.status !== 200) {
        console.log("Error al guardar el acolito");
        setErrorAlert("Error al guardar los datos del acólito.");
        error = true;
      }
      if (!error) {
        //Guardar puestos
        setLoadingText("Guardando puestos del acólito");
        const responsePuestos = await addPuestos(puestosAcolito, acolito.id);
        if (responsePuestos.status !== 200) {
          console.log("Error al agergar los puestos");
          setErrorAlert("Error al guardar los puestos del acólito.");
          error = true;
        }
      }
      if (!error) {
        //Guardar horarios
        setLoadingText("Guardando disponibilidad del acólito");
        const responseHorarios = await updateDisponibilidadAcolito(
          horarios,
          acolito.id
        );
        if (responseHorarios.status !== 200) {
          console.log("Error al agregar los horarios");
          setErrorAlert("Error al guardar la disponibilidad del acólito.");
          error = true;
        }
        setGuardando(false);
        setShowCambiosGuardados(true);
        setLoading(false);
      }
    }

    if (error) {
      setShowAlert(true);
      setGuardando(false);
      setShowModal(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {loading && <Loading texto={loadingText} />}
      <InfoPersonal acolito={acolito} setAcolito={setAcolito} />
      <Disponibilidad horarios={horarios} setHorarios={setHorarios} />
      <ConocimientoPuestos
        puestosAcolito={puestosAcolito}
        setPuestosAcolito={setPuestosAcolito}
      />
      {/* Alerta de error */}
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert
          onClose={() => setShowAlert(false)}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errorAlert}
        </Alert>
      </Snackbar>
      {/* Modal para confirmar que deseamos guardar los cambios */}
      {
        <CustomModal
          open={showModal}
          funBtn1={guardarCambios}
          funBtn2={() => setShowModal(false)}
          btnDisabled={guardando}
        />
      }
      {/* Modal para confirmar que se guardaron los cambios */}
      <CustomModal
        open={showCambiosGuardados}
        title="Acólito creado"
        text="El acólito ha sido creado exitosamente."
        txtBtn1="Regresar a la lista"
        txtBtn2="Ver acólito"
        funBtn1={() => {
          window.location.href = "/acolitos";
        }}
        funBtn2={() => {
          window.location.href = `/acolitos/${acolito.id}`;
        }}
        iconBtn1={<KeyboardReturn />}
        iconBtn2={<Info />}
        colorbtn2="success"
      />
      <div style={{ position: "fixed", bottom: 20, right: 20 }}>
        <Button
          startIcon={<Save style={{ fontSize: 20 }} />}
          sx={{
            borderRadius: 2,
            boxShadow: 8,
            transition: "transform 0.3s",
            bgcolor: "white",
            "&:hover": {
              transform: "scale(1.1)",
            },
            fontSize: 20,
            fontWeight: 900,
            padding: "10px 20px",
          }}
          onClick={() => setShowModal(true)}
        >
          Guardar
        </Button>
      </div>
    </>
  );
};
